module.exports = __webpack_public_path__ + "img/stick_nature_plage.10118742.svg";